import React, { useState } from 'react';
import { ArrowRightIcon, CheckIcon, CircleAlertIcon, SparklesIcon } from 'lucide-react';
import { readiness } from '../../data/loisirs';
export function ReadinessCard() {
  const [fixed, setFixed] = useState(false);
  return <section aria-labelledby="ready-title" className="rounded-3xl border border-slate-200 bg-white p-6 sm:p-7" data-id="element-1538" data-mp="14r49anr30azl">
      <div className="flex items-start gap-3" data-id="element-1539" data-mp="zskmkl4nyv66">
        <span className="grid h-10 w-10 shrink-0 place-items-center rounded-xl bg-ville-indigo-soft text-ville-indigo" aria-hidden="true" data-id="element-1540" data-mp="1en7ddz5hujp6">
          <SparklesIcon className="h-5 w-5" data-id="element-1541" data-mp="19odvluj6c6j7" />
        </span>
        <div className="min-w-0" data-id="element-1542" data-mp="1ngaklppjq0bd">
          <h2 id="ready-title" className="text-lg font-extrabold tracking-tight text-ville-navy" data-id="element-1543" data-mp="1nfj1vfh1rx2i">
            Ready to register
          </h2>
          <p className="mt-1 text-sm text-slate-600" data-id="element-1544" data-mp="1xdyslhc5x4bh">
            {readiness.activity} · opens {readiness.opensOn}
          </p>
        </div>
      </div>

      {fixed ? <p className="mt-5 flex items-center gap-2 rounded-2xl bg-ville-indigo-soft px-4 py-3 text-sm font-semibold text-ville-indigo" data-id="element-1545" data-mp="1sgyjsynxhngo">
          <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-1546" data-mp="21l3qwbsiyexb" />
          Everything is ready for registration {readiness.opensOn}.
        </p> : <div className="mt-5 rounded-2xl border border-slate-200 bg-slate-50 p-5" data-id="element-1547" data-mp="26jdqqzp723p9">
          <p className="flex items-start gap-2 text-[15px] font-bold text-ville-navy" data-id="element-1548" data-mp="2ama9qrinc1tq">
            <CircleAlertIcon className="mt-0.5 h-5 w-5 shrink-0 text-ville-indigo" aria-hidden="true" data-id="element-1549" data-mp="2flmwlc9ip8wb" />
            {readiness.blocking.label}
          </p>
          <p className="mt-1.5 pl-7 text-sm text-slate-600" data-id="element-1550" data-mp="2ki4y839jwr4f">{readiness.blocking.detail}</p>
          <button type="button" onClick={() => setFixed(true)} className="ml-7 mt-4 inline-flex items-center gap-2 rounded-full bg-ville-navy px-5 py-2.5 text-sm font-bold text-white transition-transform duration-150 ease-ville hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo focus-visible:ring-offset-2" data-id="element-1551" data-mp="2pbpyy32j3z7b">
            Fix it now
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-1552" data-mp="1399brzo01sr2" />
          </button>
        </div>}

      <ul className="mt-5 flex flex-wrap gap-x-5 gap-y-2" data-id="element-1553" data-mp="z85vxd5ybwpu">
        {readiness.checks.map(check => {
        const ok = fixed || check.ok;
        return <li key={check.id} className="flex items-center gap-2 text-sm" data-id="element-1554" data-mp="1d03voxdrwg9c">
              <span className={`grid h-5 w-5 place-items-center rounded-full ${ok ? 'bg-ville-indigo-soft text-ville-indigo' : 'bg-slate-200 text-slate-500'}`} aria-hidden="true" data-id="element-1555" data-mp="186854fzu9vo7">
                {ok ? <CheckIcon className="h-3 w-3" data-id="element-1556" data-mp="1hwuc5lthpdva" /> : <CircleAlertIcon className="h-3 w-3" data-id="element-1557" data-mp="1vx55qwm6p6k5" />}
              </span>
              <span className={ok ? 'text-slate-600' : 'font-semibold text-ville-navy'} data-id="element-1558" data-mp="1vwc5mehqdfaz">{check.label}</span>
            </li>;
      })}
      </ul>
    </section>;
}